import type { AgentUiCommand } from "@/agent/types";
import contract from "@/agent/v4CommandRoutes.json";

/**
 * Concrete Vue routes generated from ProductCapabilityManifest. The backend
 * snapshot test rejects a stale copy whenever an action or route changes.
 * Observational photo-state queries keep their current-page behavior.
 */
export function routeForAgentCommand(command: AgentUiCommand): string | null {
  if (command.type === "photos.queryCurrentState") return "photo-archive";
  const routes: Record<string, string> = contract.commandRoutes;
  return routes[command.type] ?? null;
}
